'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _reactRedux = require('react-redux');

var _reactUtils = require('react-utils');

var _Immutable = require('Immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _components = require('I18n/components');

var _UIButtonSelectInput = require('UIComponents/input/UIButtonSelectInput');

var _UIButtonSelectInput2 = _interopRequireDefault(_UIButtonSelectInput);

var _dates = require('MeetingsBase/constants/dates');

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DurationPicker = _React2.default.createClass({
  displayName: 'DurationPicker',

  propTypes: {
    // loaded
    durationOptions: _React.PropTypes.instanceOf(_Immutable.List).isRequired,
    selectedDuration: _React.PropTypes.number.isRequired,
    setEventDuration: _React.PropTypes.func.isRequired
  },

  handleSetEventDuration: function handleSetEventDuration(_ref) {
    var value = _ref.target.value;

    this.props.setEventDuration(value);
  },
  getCompoundTime: function getCompoundTime(hours, minutes) {
    var hourString = _I18n2.default.text('prebook.durationPicker.shortHourCount', {
      count: Math.floor(hours)
    });
    var minuteString = _I18n2.default.text('prebook.durationPicker.minuteCount', {
      count: minutes
    });
    return _React2.default.createElement(
      'b',
      null,
      _React2.default.createElement(_components.FormattedHTMLMessage, {
        message: 'prebook.durationPicker.combination',
        options: { hours: hourString, minutes: minuteString }
      })
    );
  },
  getHours: function getHours(hours) {
    return _React2.default.createElement(
      'b',
      null,
      _React2.default.createElement(_components.FormattedHTMLMessage, {
        message: 'prebook.durationPicker.hourCount',
        options: { count: hours }
      })
    );
  },
  getMinutes: function getMinutes(minutes) {
    return _React2.default.createElement(
      'b',
      null,
      _React2.default.createElement(_components.FormattedHTMLMessage, {
        message: 'prebook.durationPicker.minuteCount',
        options: { count: minutes }
      })
    );
  },
  getDurationOptionText: function getDurationOptionText(duration) {
    var minutes = _I18n2.default.moment.duration(duration).asMinutes();
    if (duration >= _dates.ONE_HOUR) {
      var remainderMinutes = _I18n2.default.moment.duration(minutes % 60).valueOf();
      var hours = _I18n2.default.moment.duration(duration).asHours();
      if (remainderMinutes !== 0) {
        return this.getCompoundTime(hours, remainderMinutes);
      } else {
        return this.getHours(hours);
      }
    }
    return this.getMinutes(minutes);
  },
  getButtonGroupOptions: function getButtonGroupOptions(durationOptions) {
    var _this = this;

    return durationOptions.map(function (duration) {
      return {
        text: _this.getDurationOptionText(duration),
        value: duration
      };
    });
  },
  renderDurationPicker: function renderDurationPicker(durationOptions) {
    var buttonGroupOptions = this.getButtonGroupOptions(durationOptions);

    var classes = (0, _reactUtils.classNames)('duration-picker width-100', {
      single: durationOptions.size === 1
    });

    return _React2.default.createElement(
      'div',
      { className: classes },
      _React2.default.createElement(
        'h5',
        null,
        _React2.default.createElement(_components.FormattedHTMLMessage, { message: 'prebook.durationPicker.header' })
      ),
      _React2.default.createElement(_UIButtonSelectInput2.default, {
        className: 'display-block',
        value: this.props.selectedDuration,
        onChange: this.handleSetEventDuration,
        defaultValue: durationOptions.first(),
        options: buttonGroupOptions
      })
    );
  },
  render: function render() {
    var durationOptions = this.props.durationOptions;


    if (!durationOptions || durationOptions.size === 0) {
      return null;
    }

    return this.renderDurationPicker(durationOptions);
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,

    selectedDuration: (0, _BookInfoSelectors.getEvent)(state).duration,
    durationOptions: (0, _BookInfoSelectors.getCustomParams)(state).durations
  };
}, {
  setEventDuration: _FormActions.setEventDuration
})(DurationPicker);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/duration/DurationPicker.js
// module id = 438
// module chunks = 0